import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Checkbox,
  Collapse,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { companyWiseEmp } from "../../actions/Companywiseclient";

const Row = ({ user, index, updateConvensePermission }) => {
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell>{index + 1}</TableCell>
        <TableCell>{`${user.name}(${user.empCode})`}</TableCell>
        <TableCell>
          <IconButton onClick={() => setOpen(!open)}>
            <KeyboardArrowDownIcon />
          </IconButton>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={3}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box>
              <Table size="small">
                <TableHead
                  style={{ color: "#fff", backgroundColor: "#32577e" }}
                >
                  <TableRow>
                    <TableCell className="tabalecellStyle">Sl No.</TableCell>
                    <TableCell className="tabalecellStyle">
                      Converse Type
                    </TableCell>
                    <TableCell className="tabalecellStyle">
                      Rate Per K.M.
                    </TableCell>
                    <TableCell className="tabalecellStyle">Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {user.convenseList.map((converse, converseIndex) => {
                    return (
                      <TableRow>
                        <TableCell>{converseIndex + 1}</TableCell>
                        <TableCell>{converse.convenseType}</TableCell>
                        <TableCell>{converse.ratePerKm}</TableCell>
                        <TableCell>
                          <Checkbox
                            checked={converse.hasPermission}
                            onChange={(e) =>
                              updateConvensePermission(
                                converse.id,
                                e.target.checked
                              )
                            }
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};

const UserReimbursement = ({ companyId, siteId }) => {
  const [searchInput, setSearchInput] = React.useState("");
  const [userList, setUserList] = React.useState([]);

  const getSetUserList = async () => {
    const response = await companyWiseEmp.getAllActiveInActiveUsers({
      companyId: companyId,
      isActive: "true",
      siteId: siteId?.id || null,
    });
    if (response && response.responseCode === 200) {
      setUserList(response.data.filter((user) => Boolean(user.convenseList)));
    } else {
      setUserList([]);
    }
  };

  const updateConvensePermission = async (id, isActive) => {
    const response = await companyWiseEmp.updateUserConvenseRatePermission({
      id,
      isActive,
    });
    alert(response?.responseDescription || response);
    getSetUserList();
  };

  React.useEffect(() => {
    if (companyId) {
      getSetUserList();
    } else {
      setUserList([]);
    }
  }, [companyId, siteId]);

  const filteredUsersList = userList.filter(
    (user) =>
      user.name.toLowerCase().includes(searchInput.toLocaleLowerCase()) ||
      user.empCode.toLowerCase().includes(searchInput.toLocaleLowerCase())
  );

  return (
    <div>
      {/* <Grid className="CompanyBox"> */}
      <Accordion className="main_accoardian" defaultExpanded={true}>
        <AccordionSummary
          className="accordianHeader"
          expandIcon={
            <AddCircleIcon fontSize="large" style={{ color: "white" }} />
          }
          aria-controls="panel1a-content"
          style={{
            background: "rgb(10 166 141)",
            borderRadius: "10px 10px 0px 0px",
            overflow: "hidden",
          }}
        >
          <Grid>
            <Grid>
              <h3
                style={{
                  color: "#fff",
                  marginLeft: "10px",
                  padding: "10px 2px",
                }}
              >
                User Reimbursement Configuration:-
              </h3>
            </Grid>
          </Grid>
        </AccordionSummary>
        <AccordionDetails>
          <TextField
            label={"Search"}
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            sx={{ my: 1 }}
          />
          <TableContainer component={Paper} sx={{ maxHeight: 500 }}>
            <Table size="small" stickyHeader>
              <TableHead sx={{ color: "#fff", backgroundColor: "#32577e" }}>
                <TableRow>
                  <TableCell
                    className="tabalecellStyle"
                    sx={{
                      color: "#fff",
                      backgroundColor: "#32577e",
                    }}
                  >
                    S. no
                  </TableCell>
                  <TableCell
                    className="tabalecellStyle"
                    sx={{
                      color: "#fff",
                      backgroundColor: "#32577e",
                    }}
                  >
                    User
                  </TableCell>
                  <TableCell
                    sx={{
                      color: "#fff",
                      backgroundColor: "#32577e",
                    }}
                  />
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredUsersList.map((user, index) => {
                  return (
                    <Row
                      key={user.id}
                      user={user}
                      index={index}
                      updateConvensePermission={updateConvensePermission}
                    />
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </AccordionDetails>
      </Accordion>
      {/* </Grid> */}
    </div>
  );
};

export default UserReimbursement;
